
import Component from "vue-class-component"
import AbstractPage from "@/report/pages/AbstractPage.vue"
import Page from "@/report/pages/Page.vue"
import MetricCircle from "@/report/components/MetricCircle.vue"

@Component({
  name: "RankingPage",
  components: {
    Page,
    MetricCircle,
  },
})
export default class RankingPage extends AbstractPage {
  private totalRank(): number {
    const ranking = this.lastSnapshot.planRanking
    /* eslint-disable @typescript-eslint/restrict-plus-operands */
    return (
      ranking.rankLoggedIn +
      ranking.rankAdequateRetirementStandard +
      ranking.rankNominatedBeneficiary
    )
  }

  get quartile(): string {
    const total = this.totalRank()
    return total > 225
      ? "TOP"
      : total > 150
      ? "2ND"
      : total > 75
      ? "3RD"
      : "4TH"
  }

  get icon(): string {
    return this.totalRank() > 150 ? this.$icons.imTrophy : this.$icons.imDanger
  }
}
